'use client';

import React, { useMemo } from 'react';
import { GlobalContext } from './GlobalContext';
import { useSelector, shallowEqual } from 'react-redux';
import { getRequestKey } from '../../components/atoms/datatools/getRequestKey';

export const GlobalProvider = ({ children }) => {
  const [configuration, media, locale, defaultLanguage] = useSelector(
    (state) => [
      state.app.context.project.configuration,
      state.app.context.project.configuration.media,
      state.app.context.locale,
      state.app.context.project.defaultLanguage,
    ],
    shallowEqual,
  );

  // Key for DataTools
  const { requestKey } = getRequestKey();

  const values = useMemo(() => {
    return {
      configuration,
      media,
      locale,
      defaultLanguage,
      requestKey,
    };
  }, [configuration, media, defaultLanguage, locale, requestKey]);

  return (
    <GlobalContext.Provider value={values}>{children}</GlobalContext.Provider>
  );
};
